/* Config */
const wpUrl = '/wp-json/wp/v2/';
const url = '/wp-json/sodecia/';
const api = {
	submit_application: {
		form: `${url}v1/submit-application/`,
	},
	locations_coordenates: `${wpUrl}sodecia_location?per_page=100&_fields=lat,long`,
};

export default api;

export function checkStatus(response) {
	if (response.status >= 200 && response.status < 300) {
		return response;
	} else {
		var error = new Error(response.statusText);
		error.response = response;
		throw error;
	}
}

export function parseJSON(response) {
	return response.json();
}

export function errorResponse(response) {
	throw Error(response);
}



// WEBPACK FOOTER //
// ./scripts/util/api.js